<div class="row">
    <div class="large-12 columns">
        <textarea matInput [(ngModel)]="data.tempComment" class="comment-add-box"></textarea>
    </div>
</div>
<div class="row comment-add-box-action-button-container">
    <div class="large-12 columns">
        <app-button-list>
            <app-button (clickedEvent)="saveNotes()" [icon]="'save'">Save </app-button>
            <app-button (clickedEvent)="onClose()" [icon]="'cancel'">Cancel </app-button>
        </app-button-list>
    </div>
</div>

